import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import EditForm from 'components/event/EditForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';
import { cancelEditingEvent, updateEvent } from 'actions/Event';
import { RoleHelper } from '@shoflo/polymer/helpers/RoleHelper/RoleHelper';
import PropTypes from 'prop-types';

import { getTeamMembers, getTeam, createTeamLabel } from 'actions/Team';

import { Modal } from 'reactstrap';

const EditEventModal = ({
  event,
  modalOpen,
  cancelEditingEvent,
  updateEvent,
  getTeamMembers,
  getTeam,
  team,
  user,
  teamMembers,
  createTeamLabel,
}) => {
  useEffect(() => {
    if (!event) return;

    const teamId = event.team._id ? event.team._id : event.team;

    getTeam(teamId);
    getTeamMembers(teamId);
  }, [event, getTeam, getTeamMembers]);

  if (!event) return null;

  const isTeamAdmin = RoleHelper.hasTeamAdminRole(user, team?._id);

  const readyToShowForm = event && teamMembers;
  const teamId = event ? (event.team._id ? event.team._id : event.team) : null;

  const labels = team ? team.labels : [];

  return (
    <Modal isOpen={modalOpen} toggle={cancelEditingEvent}>
      <StyledModalHeader toggle={cancelEditingEvent}>
        Edit event settings
      </StyledModalHeader>
      <StyledModalBody>
        {readyToShowForm && (
          <EditForm
            event={event}
            onSubmit={(formData, photoFile, labelIds) => {
              updateEvent(teamId, event._id, formData, photoFile, labelIds);
            }}
            owners={teamMembers}
            labels={labels}
            onLabelCreated={createTeamLabel.bind(null, teamId)}
            onCancel={cancelEditingEvent}
            team={team}
            isTeamAdmin={isTeamAdmin}
          />
        )}
      </StyledModalBody>
    </Modal>
  );
};

EditEventModal.propTypes = {
  modalOpen: PropTypes.bool,
  event: PropTypes.object,
  cancelEditingEvent: PropTypes.func,
  updateEvent: PropTypes.func,
  getTeamMembers: PropTypes.func,
  getTeam: PropTypes.func,
  team: PropTypes.object,
  user: PropTypes.object,
  teamMembers: PropTypes.array,
  createTeamLabel: PropTypes.func,
};

export default connect(
  (state) => {
    const { editingEvent, selectedTeamMembers, team, user } = state;

    return {
      team,
      user,
      modalOpen: editingEvent ? true : false,
      event: editingEvent,
      teamMembers: selectedTeamMembers,
    };
  },
  {
    updateEvent,
    cancelEditingEvent,
    createTeamLabel,
    getTeamMembers,
    getTeam,
  },
)(EditEventModal);
